<template>
  <b-container fluid>
    <b-row class="justify-content-center m-4">
      <b-col md="10">
        <b-form @submit.stop.prevent="onSubmit">
          <b-form-group v-for="control in controls"
                        :key="control.caption"
                        :label="control.caption"
                        :label-for="control.type"
                        label-align="right"
                        label-cols-sm="6"
                        label-cols-lg="4"
                        :invalid-feedback="getError(control.type + 'input')"
                        :state="validateState(control.type + 'input')"
          >
            <a-month-picker v-if="control.type==='yearmonth'"
                            :id="control.type"
                            v-model="value1"
                            size="large"
                            @change="onChangeYearMonth(control.values)"
                            format="MM/YYYY"
                            placeholder="Выберите месяц"
                            :name="control.type + 'input'"
                            v-validate="validation.value1"
                            data-vv-as="Месяц год"
                            :state="validateState(control.type + 'input')"
            />
            <!--<a-range-picker v-if="control.type==='datetime_range'"-->
            <!--:id="control.type"-->
            <!--v-model="value2"-->
            <!--size="large"-->
            <!--format="DD/MM/YYYY HH:mm"-->
            <!--:placeholder="['Дата с', 'Дата по']"-->
            <!--@change="onChangeDateTime(control.values)"-->
            <!--:name="control.type + 'input'"-->
            <!--v-validate="validation.value2"-->
            <!--data-vv-as="Даты"-->
            <!--:state="validateState(control.type + 'input')"-->
            <!--/>-->
            <ctk-date-time-picker v-if="control.type==='datetime_range'"
                                  :id="control.type"
                                  v-model="value2"
                                  :custom-shortcuts="customShortcuts"
                                  label="Дата с"
                                  color="#40b539"
                                  locale="ru"
                                  range
                                  @input="onChangeDate"
                                  format="YYYY-MM-DDTHH:mm"
                                  formatted="llll"
                                  class="col-md-9 m-0"
                                  :name="control.type + 'input'"
                                  v-validate="validation.value2"
                                  data-vv-as="Даты"
                                  :state="validateState(control.type + 'input')"
            >
            </ctk-date-time-picker>
            <b-form-select v-if="control.type==='radio'||control.type==='select'"
                           :id="control.type"
                           :options="control.data"
                           v-model="value3"
                           @change="onChangeSelect(control.values)"
                           value-field="id"
                           text-field="name"
                           class="col-sm-7"
                           :name="control.type + 'input'"
                           v-validate="validation.value3"
                           data-vv-as="Данные"
                           :state="validateState(control.type + 'input')"
            >
            </b-form-select>
          </b-form-group>
          <b-row class="justify-content-center">
            <b-button type="button" variant="success" class="text-center"
                      @click="reportData({query, name:'web'})" :disabled="veeErrors.any()">Загрузить отчет
            </b-button>
            <b-button type="button" variant="outline-success ml-4" class="text-center"
                      @click="excelReportData({query, name:'excel'})" :disabled="veeErrors.any()">Выгрузить
              в excel
            </b-button>
          </b-row>

        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import CtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'controls',
  components: {
    CtkDateTimePicker
  },
  data () {
    return {
      value1: null,
      value2: null,
      value3: null,
      query: {},
      customShortcuts: [
        { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
        { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
        { key: 'thisYear', label: 'Этот год', value: 'year' }
      ],
      validation: {
        value1: {
          required: true
        },
        value2: {
          required: true
        },
        value3: {
          required: true
        }
      }
    }
  },
  watch: {
    '$route.params.name' () {
      this.query = {}
      this.value1 = null
      this.value2 = null
      this.value3 = null
    }
  },
  computed: {
    ...mapState(
      {
        controls: state => state.reports.controls
      }
    )
  },
  methods: {
    onChangeDate (params) {
      const dateObj = {}
      dateObj.d1 = params.start
      dateObj.d2 = params.end
      Object.assign(this.query, dateObj)
    },
    onChangeYearMonth (date) {
      Object.assign(this.query, { p_month: this.value1._d.getMonth() + 1, p_year: this.value1._d.getFullYear() })
    },
    onChangeSelect (date) {
      Object.assign(this.query, { p_tt: this.value3 })
    },
    getError (ref) {
      return this.veeErrors.first(ref)
    },
    validateState (ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    onSubmit (query) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        if (query.name === 'web') {
          this.getReportData(query.query)
        } else if (query.name === 'excel') {
          this.getReportExcelData(query.query)
        }
      })
    },
    reportData (query) {
      event.preventDefault()
      this.onSubmit(query)
    },
    excelReportData (query) {
      event.preventDefault()
      this.onSubmit(query)
    },
    ...mapMutations('reports',
      [
        'setMonthYear'
      ]
    ),
    ...mapActions('reports',
      [
        'getReportData',
        'getReportExcelData'
      ]
    )
  }
}
</script>

<style scoped>

</style>
